import React from 'react';

/**
 * HFF triangle logo rendered from the actual brand PNG asset.
 *
 * @param {number}  [size=48]       - Width & height in pixels.
 * @param {string}  [className]     - Extra class names.
 * @param {boolean} [light=false]   - Invert to white (for dark backgrounds).
 * @param {object}  [style]         - Extra inline styles.
 */
export default function TriangleLogo({ size = 48, className = '', light = false, style }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/logo.png`}
      alt="HFF Logo"
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: 'contain',
        ...(light ? { filter: 'brightness(0) invert(1)' } : {}),
        ...style,
      }}
    />
  );
}
